export default {
  relatory: {
    label: 'analytics.details.relatory',
    type: 'general',
    field: 'relatory',
    align: 'left',
    customWidth: 220,
    render: true,
    fixed: false,
    order: 1

  },

}
